import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import App from "apps/messenger/components/App";

import * as actionCreators from "ducks/global_messaging";

const mapStateToProps = (state) => state.globalMessaging;

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		actionCreators,
		dispatch,
	);
};

// Connected instance of the messenger.
export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(App);



// WEBPACK FOOTER //
// ./src/apps/messenger/containers/App.js